export const SPC_CHARTS_MAP = {
  I: {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.I_CHART',
  },
  MR: {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.MR_CHART',
  },
};

export const MODEL_NAME = 'SPC Model';
export const PRIMARY = 'Primary';
export const SECONDARY = 'Secondary';
export const DEFAULT_COLOR = '#000000';
export const DEFAULT_NAME = 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.HEADER';
export const SHOW_OPERATIONALIZE_STATS_SUMMARY_TOOL = false;

export const INPUT_NAMES = {
  signalInput: 'signal',
  restrictOutputToConditionInput: 'condition',
  baselineInput: 'baseline',
};

export const DEFAULT_PRIMARY_OUTPUTS: string[] = [
  'Primary Chart',
  'Primary Chart Centerline',
  'Primary Chart ucl',
  'Primary Chart lcl',
];

export const DEFAULT_SECONDARY_OUTPUTS: string[] = [
  'Secondary Chart',
  'Secondary Chart Centerline',
  'Secondary Chart ucl',
  'Secondary Chart lcl',
];

export const DEFAULT_OUTPUTS: string[] = [...DEFAULT_PRIMARY_OUTPUTS, ...DEFAULT_SECONDARY_OUTPUTS];

export const OUTPUT_TRANSLATION_KEYS: Record<string, Record<string, string>> = {
  'Primary Chart': {
    label: '',
    icon: 'fc fc-series',
  },
  'Secondary Chart': {
    label: '',
    icon: 'fc fc-series',
  },
  'Primary Chart Centerline': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.CENTERLINE',
    icon: 'fc fc-scalar',
  },
  'Primary Chart ucl': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.UCL',
    icon: 'fc fc-scalar',
  },
  'Primary Chart lcl': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.LCL',
    icon: 'fc fc-scalar',
  },
  'Primary Chart plus1sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.PLUS_1_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Primary Chart plus2sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.PLUS_2_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Primary Chart minus1sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.MINUS_1_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Primary Chart minus2sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.MINUS_2_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Primary Chart standarddeviation': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.STANDARD_DEVIATION',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart Centerline': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.CENTERLINE',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart ucl': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.UCL',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart lcl': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.LCL',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart plus1sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.PLUS_1_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart plus2sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.PLUS_2_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart minus1sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.MINUS_1_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart minus2sigma': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.MINUS_2_SIGMA',
    icon: 'fc fc-scalar',
  },
  'Secondary Chart standarddeviation': {
    label: 'INVESTIGATE_TOOLS.OPERATIONALIZE_STATISTICS_SUMMARY.OUTPUTS.STANDARD_DEVIATION',
    icon: 'fc fc-scalar',
  },
};
